import { IFlyerDetailPage } from "../../../../../../../types/flyer-detail-data/flyer-detail-page/flyer-detail-page.interface";
import { FlyerDetailPageForm } from "./flyer-detail-page-form.interface";

export function createFlyerDetailPageForm(page: IFlyerDetailPage): FlyerDetailPageForm {
  return {
    notes: page.notes || "",
    theme: page.theme || "",
  };
}
